/* Blue Monkey: mega-menu hover-intent fix for Horizon theme.
   Adds a short grace period before the dropdown closes, so moving the
   mouse diagonally from the top-level link to the panel doesn't close it. */
(function () {
  var CLOSE_DELAY = 300; // ms

  customElements.whenDefined('header-menu').then(function () {
    var HeaderMenu = customElements.get('header-menu');
    var originalDeactivate = HeaderMenu.prototype.deactivate;
    if (!originalDeactivate || originalDeactivate.__bmPatched) return;

    var patched = function (event) {
      // Keyboard/focus behavior stays exactly as the theme intended
      if (!event || event.type !== 'pointerleave') return originalDeactivate.call(this, event);

      var self = this;
      clearTimeout(self.__bmCloseTimer);
      self.__bmCloseTimer = setTimeout(function () {
        // If the pointer is back over any top-level item or its open panel, keep it open
        if (self.querySelector('.menu-list__list-item:hover')) return;
        originalDeactivate.call(self, event);
      }, CLOSE_DELAY);
    };
    patched.__bmPatched = true;
    HeaderMenu.prototype.deactivate = patched;
  });
})();